import {
  PerspectiveCamera,
  OrthographicCamera,
  Vector3,
}               from 'three';
import Controls from './OrbitControls'

export default class Camera {
  constructor(domElement) {
    this.domElement = domElement;
    this.width = this.domElement.clientWidth;
    this.height = this.domElement.clientHeight
    this.aspect = this.width / this.height;
    this.orthographicWidth = 3000
    this.orthographicHeight = this.orthographicWidth / this.aspect

    this.perspective = {}
    this.perspective.camera = new PerspectiveCamera(45, this.aspect, 0.1, 1000000);
    this.perspective.controls = new Controls(this.perspective.camera, domElement)
    this.perspective.controls.addEventListener('change', () => {
      this._onCameraUpdate()
    })

    this.orthographic = {}
    this.orthographic.camera = new OrthographicCamera( this.orthographicWidth / - 2, this.orthographicWidth / 2, this.orthographicHeight / 2, this.orthographicHeight / -2, -100000, 1000000 );
    this.orthographic.controls = new Controls(this.orthographic.camera, domElement)
    this.orthographic.controls.addEventListener('change', () => {
      this._onCameraUpdate()
    })

    this.zoom = 1
    this.position = new Vector3(1200, 1200, 1200)
    this.originalPerspectivCameraDistance = this.position.distanceTo(this.perspective.controls.target)
    this.setMode('perspective')
  }

  _onCameraUpdate() {
    if (this.camera instanceof PerspectiveCamera) {
      this.zoom = this.originalPerspectivCameraDistance / this.camera.position.distanceTo(this.controls.target)
    } else {
      this.zoom = this.camera.zoom
    }

    if (typeof this.onCameraUpdate === 'function') {
      this.onCameraUpdate()
    }
  }

  update() {
    this.controls.update()
  }
  
  setMode(mode) {
    if (this.controls) {
      this.controls.enabled = false
    }

    if (this.camera) {
      this.position.copy(this.camera.position)
    }

    if (mode === 'orthographic') {
      this.camera = this.orthographic.camera
      this.camera.zoom = this.zoom
      this.controls = this.orthographic.controls
    }
    else {
      this.camera = this.perspective.camera
      this.position.normalize().multiplyScalar(this.originalPerspectivCameraDistance / this.zoom)
      this.controls = this.perspective.controls
    }

    this.mode = mode
    this.camera.position.set(this.position.x, this.position.y, this.position.z)
    this.camera.lookAt(new Vector3())
    this.camera.updateProjectionMatrix()
    this.controls.enabled = true
    this.controls.update()

    if (typeof this.onModeChange === 'function') {
      this.onModeChange()
    }

    return this.camera
  }

  toggleMode() {
    if (this.mode === 'perspective') {
      this.setMode("orthographic");
    }
    else {
      this.setMode('perspective')
    }
    return this.camera
  }
  enableZoom(val){
    this.perspective.controls.enableZoom = val
    this.orthographic.controls.enableZoom = val
  }
}
